import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import TeleImg from "../../images/telecom.jpg";

const TelecomHero = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100vh",
        backgroundImage: `url(${TeleImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Soft overlay for readability */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: "rgba(0,0,0,0.12)",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            bgcolor: "rgba(22, 45, 180, 0.82)",
            px: { xs: 3, md: 6 },
            py: { xs: 4, md: 6 },
            width: "100%",
            maxWidth: 1180,
            mx: "auto",
          }}
        >
          <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
            {/* Left: Title */}
            <Grid item xs={12} md={5}>
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 800,
                  letterSpacing: "-0.5px",
                  fontSize: { xs: 35, sm: 45, md: 58 },

                  lineHeight: { xs: 1.05, md: 1.0 },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Telecom
                <br />
                Solutions
              </Typography>
            </Grid>

            {/* Middle: Divider */}
            <Grid
              item
              xs={12}
              md={1}
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: "2px",
                  height: 190,
                  bgcolor: "rgba(255,255,255,0.7)",
                }}
              />
            </Grid>

            {/* Right: Description */}
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.95)",
                  fontSize: { xs: 14, md: 16 },

                  lineHeight: 1.9,
                  fontWeight: 600,
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                The Telecom industry is evolving towards software-based agile
                infrastructure with programmable automated processes. Our remote
                infrastructure management, integrated operations, network
                operation management and hybrid cloud services bring efficiency,
                scalability and flexibility to Telecom operations as the
                industry witnesses business and IT transformation. From managing
                our client's own infrastructure to undergoing a complete
                buildout and deployment of a new datacenter, our digital
                workplace solution integrates consumers, partners, and employees
                on one seamless platform to enhance consumer and employee
                delight. Our data security solutions provide protection and
                compliance for the industry as it increasingly embraces digital
                business models. With the proliferation of smart devices and
                upgraded networks, Telecom providers must deal with a massive
                amount of data on customers’ behavior, preferences, movements,
                call center interactions, and tower logs. Big data optimization
                helps in driving cost efficiency and enhancing customer loyalty.
                AlphaForce provides analytics in network infrastructure
                management and market segmentation.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

const Telecom = () => {
  return (
    <Box>
      <TelecomHero />
      {/* Add the rest of the Telecom page sections below */}
    </Box>
  );
};

export default Telecom;
